import React, { useEffect, useState } from 'react';

import { withStyles } from '@material-ui/core';
import ContentLoader from '../loaders/ContentLoader';
import BoligmappaLogo from '../../assets/icons/BoligmappaLogo';
import styles from './style';
import { getPropertyAddress } from '../../utils/properties';

const PublicPropertyAddress = ({ classes, property }) => {
  const [addressValue, setAddressValue] = useState('');

  useEffect(() => {
    setAddressValue(getPropertyAddress(property));
  });

  return (
    <div className={classes.container}>
      <div className={classes.logo}>
        {!addressValue ? (
          <ContentLoader width={30} height={30} variant="circle" />
        ) : (
          <BoligmappaLogo className={classes.logoImage} />
        )}
      </div>

      <div className={classes.propertyAddressContainer}>
        {!addressValue ? (
          <ContentLoader height={20} width={160} />
        ) : (
          <>
            <strong className={classes.propertyAddress}>{addressValue}</strong>
          </>
        )}
      </div>
    </div>
  );
};
export default withStyles(styles)(PublicPropertyAddress);
